import Image from "components/Elements/Image/Image";
import Icon from "components/Elements/Icon/Icon";
import Button, { ButtonA } from "components/Elements/Button/Button";
import { useContent } from "contexts/contentContext/contentContext";
import { useModal } from "contexts/modalContext/modalContext";

import styles from "./pickerPromoModals.module.scss";

const PickerPromoSidebarModal = () => {
  const { getHtmlByKey, getTextByKey } = useContent();
  const { closeModal } = useModal();

  return (
    <div className={styles.sideBarModal + " " + styles.container}>
      <Image
        name="home/picker-promo-sidebar-modal"
        ext="png"
        className={styles.image}
      />
      <h3>{getHtmlByKey("picker-promo-sidebar-modal-title")}</h3>
      <div className={styles.text}>
        <p>{getHtmlByKey("picker-promo-sidebar-modal-text")}</p>
        <p>
          <Icon name="warning-light" />
          {getHtmlByKey("picker-promo-sidebar-modal-warning-text")}
        </p>
      </div>
      <div className={styles.buttons}>
        <Button
          onClick={closeModal}
          className={styles.cancelButton}
          title={getTextByKey("continue-sending")}
        />
        <ButtonA
          page="inbox?t=picker&create=true"
          className={styles.sendButton}
        >
          {getTextByKey("create")}
        </ButtonA>
      </div>
    </div>
  );
};

export default PickerPromoSidebarModal;
